import { useInView } from 'react-intersection-observer'
import CountUp from 'react-countup'
import { useTranslation } from 'next-i18next'
import Reveal from '../../home-new/Reveal'
import styles from './CompanyStats.module.scss'

// "บริษัท ชิปป๊อป จำกัด" section — intro copy + highlighted tagline pill +
// 3 stat cards (founding date / startup awards / parcels handled). The
// parcels stat reuses the SAME totalParcel figure the old AboutNew hero
// counted up. Styling migrated from makeStyles to a static CSS Module.
const StatCard = ({ stat, totalParcel }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 })
  const parcelsInMillions = totalParcel
    ? Math.max(1, Math.floor(Number(totalParcel) / 1000000))
    : 83

  return (
    <div ref={ref} className={styles.statItem}>
      <picture style={{ display: 'contents' }}>
        <source
          srcSet={`/static/img/about-us-new/${stat.icon}.webp`}
          type="image/webp"
        />
        <img
          src={`/static/img/about-us-new/${stat.icon}.png`}
          alt=""
          className={styles.icon}
          width={stat.w}
          height={stat.h}
          loading="lazy"
          decoding="async"
        />
      </picture>
      <span className={styles.pill}>
        {stat.key === 'founded' && stat.date}
        {stat.key === 'awards' && (
          <>
            {inView ? <CountUp end={stat.end} duration={2} /> : '0'}
            {stat.suffix}
          </>
        )}
        {stat.key === 'parcels' && (
          <>
            {inView ? <CountUp end={parcelsInMillions} duration={2} /> : '0'}
            {stat.suffix}
          </>
        )}
      </span>
      <p className={styles.statLabel}>{stat.label}</p>
    </div>
  )
}

const CompanyStats = ({ totalParcel }) => {
  const { t } = useTranslation('about-us')

  const stats = [
    {
      key: 'founded',
      icon: 'stat-founded',
      w: 188,
      h: 190,
      date: t('about.new.company.stat-founded-date'),
      label: t('about.new.company.stat-founded-label'),
    },
    {
      key: 'awards',
      icon: 'stat-awards',
      w: 166,
      h: 173,
      end: 10,
      suffix: t('about.new.company.stat-awards-suffix'),
      label: t('about.new.company.stat-awards-label'),
    },
    {
      key: 'parcels',
      icon: 'stat-parcels',
      w: 161,
      h: 175,
      suffix: t('about.new.company.stat-parcels-suffix'),
      label: t('about.new.company.stat-parcels-label'),
    },
  ]

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <Reveal>
          <h2 className={styles.heading}>
            {t('about.new.company.heading-prefix')}{' '}
            <span>{t('about.new.company.heading-brand')}</span>{' '}
            {t('about.new.company.heading-suffix')}
          </h2>
          <p className={styles.desc}>{t('about.new.company.desc')}</p>
          <p className={styles.tagline}>{t('about.new.company.tagline')}</p>
        </Reveal>
        <div className={styles.gridContainer}>
          {stats.map((stat, i) => (
            <div className={styles.gridItem} key={stat.key}>
              <Reveal delay={i * 0.12}>
                <StatCard stat={stat} totalParcel={totalParcel} />
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CompanyStats
